import { useState } from "react";
import { FaEdit, FaSave, FaTrash } from "react-icons/fa";
import dayjs, { Dayjs } from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/";

const ExpenseTable = ({ expensesPaginated, categories, onSave, onDelete }) => {
  const [editingExpense, setEditingExpense] = useState(null);
  const [editedExpense, setEditedExpense] = useState({});

  const handleEdit = (expense) => {
    setEditingExpense(expense._id);
    setEditedExpense(expense);
  };

  const handleSave = () => {
    if (isNaN(editedExpense.amount) || editedExpense.amount === "") {
      alert("Amount must be a number");
      return;
    }
    onSave(editedExpense);
    setEditingExpense(null);
    setEditedExpense({});
  };
  const sortedExpenses = [...expensesPaginated].sort(
    (a, b) => new Date(b.date) - new Date(a.date)
  );

  return (
    <table className="w-full mt-5 bg-gray-100 rounded-t-lg shadow-lg text-xs">
      <thead>
        <tr className="bg-gray-400">
          <th className="py-1 px-1 border-b-2 border-gray-300 text-left">
            Date
          </th>
          <th className="py-1 px-1 border-b-2 border-gray-300 text-left">
            $
          </th>
          <th className="py-1 px-1 border-b-2 border-gray-300 text-left">
            Category
          </th>
          <th className="py-1 px-1 border-b-2 border-gray-300 text-left">
            Description
          </th>
          <th className="py-1 px-1 border-b-2 border-gray-300 text-left">
            Edit
          </th>
        </tr>
      </thead>
      <tbody>
        {sortedExpenses.map((expense) => (
          <tr key={expense._id} className="hover:bg-gray-50">
            {" "}
            {editingExpense === expense._id ? (
              <>
                {" "}
                <td className="p-0 align-middle">
                  {" "}
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    {" "}
                    <DatePicker
                      value={dayjs(editedExpense.date)}
                      onChange={(e) =>
                        setEditedExpense({ ...editedExpense, date: e })
                      }
                      className="w-full p-2"
                    />{" "}
                  </LocalizationProvider>{" "}
                </td>{" "}
                <td className="align-middle">
                  {" "}
                  <input
                    type="number"
                    value={editedExpense.amount}
                    onChange={(e) =>
                      setEditedExpense({
                        ...editedExpense,
                        amount: e.target.value,
                      })
                    }
                    className="w-full p-1 border border-gray-300 rounded-md text-xs"
                  />{" "}
                </td>{" "}
                <td className="align-middle">
                  {" "}
                  <select
                    value={editedExpense.category}
                    onChange={(e) =>
                      setEditedExpense({
                        ...editedExpense,
                        category: e.target.value,
                      })
                    }
                    className="w-full p-1 border border-gray-300 rounded-md text-xs"
                  >
                    {" "}
                    {categories.map((category) => (
                      <option key={category} value={category}>
                        {" "}
                        {category}{" "}
                      </option>
                    ))}{" "}
                  </select>{" "}
                </td>{" "}
                <td className="align-middle">
                  {" "}
                  <input
                    type="text"
                    value={editedExpense.description}
                    onChange={(e) =>
                      setEditedExpense({
                        ...editedExpense,
                        description: e.target.value,
                      })
                    }
                    className="w-full p-1 border border-gray-300 rounded-md text-xs"
                  />{" "}
                </td>{" "}
                <td className="grid grid-cols-2 gap-2 grid-flow-col justify-stretch text-center align-middle">
                  {" "}
                  <FaSave
                    onClick={handleSave}
                    className="cursor-pointer text-gray-700 self-center m-3 mr-2 mt-5"
                  />{" "}
                  <FaTrash
                    onClick={() => onDelete(expense._id)}
                    className="cursor-pointer text-gray-700 self-center m-3 ml-2 mt-5"
                  />{" "}
                </td>
              </>
            ) : (
              <>
                <td className="py-1 px-1 border-b border-gray-300 text-xs">
                  {new Date(expense.date).toLocaleDateString()}
                </td>
                <td className="py-1 px-1 border-b border-gray-300 text-xs font-bold">
                  ${expense.amount}
                </td>
                <td className="py-1 px-1 border-b border-gray-300 text-xs">
                  {expense.category}
                </td>
                <td className="py-1 px-1 border-b border-gray-300 text-xs italic">
                  {expense.description}
                </td>
                <td className="py-1 px-1 border-b border-gray-300 text-xs">
                  <FaEdit
                    onClick={() => handleEdit(expense)}
                    className="cursor-pointer text-gray-700 m-3"
                  />
                </td>
              </>
            )}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default ExpenseTable;
